import { tv } from "../../variants/tv.js";
const liVariants = tv({
    base: '[&_p]:m-0 [&_p]:leading-[inherit]',
    variants: {}
});
export { liVariants };
